"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rate = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var _reactI18next = require("react-i18next");
var _ticker = require("../../../ticker");
var _ui = require("../../../ui");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var FormText = (0, _styledComponents.default)(_reactstrap.FormText)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n  color: ", " !important;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
});
var Price = (0, _styledComponents.default)(_ui.ExtraSmall)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-right: 20px;\n"])));
var FiatPrice = _styledComponents.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.tertiaryShade;
});
var Rate = function Rate(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('libCommon'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(FormText, {
    className: props.className
  }, /*#__PURE__*/_react.default.createElement(Price, null, /*#__PURE__*/_react.default.createElement(_ui.MediumSpan, null, "1.00 ", props.ticker, " "), /*#__PURE__*/_react.default.createElement(FiatPrice, null, "= ", /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    value: props.price,
    ticker: props.convertedTicker
  }), ' ', props.convertedTicker)), /*#__PURE__*/_react.default.createElement(_ui.ExtraSmall, null, t('source'), ":", ' ', /*#__PURE__*/_react.default.createElement(_ui.A, {
    href: "https://www.binance.com",
    target: "_blank"
  }, "binance.com")));
};
exports.Rate = Rate;